import { Box } from '@factorialco/deprecated-design-system'
import {
  ComplianceExtraFieldsConfigsFieldFragment,
  SaleInvoiceComplianceExtraFieldsFieldFragment,
} from 'generated/resources/graphql'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

interface ComplianceExtraFieldSelectorProps {
  isCreditNote: boolean
  complianceExtraFieldsConfigsField: ComplianceExtraFieldsConfigsFieldFragment
  complianceExtraFields: SaleInvoiceComplianceExtraFieldsFieldFragment[]
  onChange: (value: string) => void
  error?: string
  readOnly?: boolean
  mandatory?: boolean
}

export const ComplianceExtraFieldSelector: React.FC<ComplianceExtraFieldSelectorProps> = ({
  isCreditNote,
  complianceExtraFieldsConfigsField,
  complianceExtraFields,
  onChange,
  error,
  readOnly = false,
  mandatory = false,
}) => {
  const isVisible = isCreditNote
    ? complianceExtraFieldsConfigsField.visibleForCreditNote
    : complianceExtraFieldsConfigsField.visibleForStandardInvoice

  const complianceExtraFieldSelected = complianceExtraFields.find(
    (field) => field.name === complianceExtraFieldsConfigsField.name
  )

  // Don't render the component if it's not visible
  if (!isVisible) {
    return null
  }

  const options =
    complianceExtraFieldsConfigsField.allowedValues?.map((allowedValue) => {
      return (
        <Selector.Option
          key={allowedValue.value}
          value={allowedValue.value}
          label={String(allowedValue.label)}
          searchValue={String(allowedValue.label)}
        >
          {allowedValue.label}
        </Selector.Option>
      )
    }) || []

  return (
    <Box gap="s8" width="full">
      <Selector.Popover
        mandatory={mandatory}
        value={complianceExtraFieldSelected?.value ? [complianceExtraFieldSelected.value] : []}
        blankLabel=""
        label={complianceExtraFieldsConfigsField.label}
        placeholder={i18n.t('common.select') + ' ' + complianceExtraFieldsConfigsField.label}
        // eslint-disable-next-line no-type-assertion/no-type-assertion
        onChange={(value) => onChange(value as string)}
        inputStyle="text"
        isDisabled={readOnly}
        hasSearch={false}
        error={error}
      >
        {options}
      </Selector.Popover>
    </Box>
  )
}
